
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M8 1.333a3.334 3.334 0 00-.667 6.6v3.4a.667.667 0 001.334 0v-3.4A3.334 3.334 0 008 1.333zm2 3.334a2 2 0 11-4.001-.001A2 2 0 0110 4.667zm-7.077 6.312c.75-.215 1.714-.313 2.653-.312.335 0 .606.298.606.667 0 .368-.272.666-.606.666-.88 0-1.733.093-2.347.269-.296.085-.498.178-.617.262.04.03.1.07.188.115.303.156.767.292 1.355.4 1.162.214 2.64.287 3.845.287 1.206 0 2.683-.074 3.845-.287.587-.108 1.052-.244 1.355-.4a1.18 1.18 0 00.194-.12 1.245 1.245 0 00-.148-.084c-.265-.13-.655-.23-1.092-.301-.428-.07-.862-.105-1.191-.123-.164-.01-.3-.014-.395-.016L10.459 12h-.034c-.336 0-.607-.298-.607-.667 0-.368.272-.666.607-.666v.666-.666h.046a11.971 11.971 0 01.552.019c.351.019.827.057 1.308.136.471.077.99.198 1.408.402.368.18.928.563.928 1.294 0 .723-.549 1.127-.953 1.336-.453.233-1.046.393-1.67.507-1.257.231-2.81.306-4.044.306-1.234 0-2.787-.075-4.045-.306-.623-.114-1.216-.274-1.669-.507-.405-.208-.953-.613-.953-1.335 0-.516.299-.867.578-1.076.281-.211.641-.358 1.012-.464zm10.549 1.617l-.005-.008.004.007zm-.008-.138l.002-.004-.002.004zm-10.93-.004l.002.005-.003-.005zm-.006.149l-.004.005s0-.002.004-.005z","clip-rule":"evenodd"}})])
          )
        }
      }
    